<template>
  <div class="container justify-content-center mt-5 company-payment-page">
    <div v-if="company">
      <a @click="goBack()" href="#" v-if="hasManagementAccess"
        ><span><i class="fa fa-arrow-left"></i></span><span class="ml-2">{{ $t(LangConstants.back_to_overview_button_label) }}</span></a
      >
      <div class="row mt-4 mb-5">
        <div class="col-8">
          <h1>{{ companyName }}</h1>
        </div>
        <div class="col-4" v-if="hasManagementAccess">
          <b-row class="mr-2" align-h="end">
            <toggle-simple :labelEnable="$t(LangConstants.activation_toggle_label)" v-model="company.active" label="" margins="mb-0" :labelDisable="$t(LangConstants.inactivation_toggle_label)" :checked="company.active" ref="activate" @toggle="updateCompanyActivation"></toggle-simple>
          </b-row>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-12 form1">
          <div class="row d-flex justify-content-center">
            <div class="col-md-4 mb-4">
              <dashboard-item fa="users" :contentItems="participantContentItems" :title="$t(LangConstants.participants_title)" :text="$t(LangConstants.participant_invoice_helper_text)" bgvariant="grey" textvariant="dark" actionbuttontext="" actionbuttonroute="/"></dashboard-item>
            </div>
            <div class="col-md-4 mb-4">
              <dashboard-item fa="trophy" :contentItems="courseCompletionContentItems" :title="$t(LangConstants.portal_coursecompletions_title)" :text="$t(LangConstants.portal_coursecompletions_helper_text)" bgvariant="yellow" textvariant="dark" placeholder="placeholder"></dashboard-item>
            </div>
            <div class="col-md-4 mb-4">
              <dashboard-item fa="bell" :contentItems="courseRenewalContentItems" :title="$t(LangConstants.portal_certificaterenewals_title)" :text="$t(LangConstants.portal_certificaterenewals_helper_text)" bgvariant="blue" textvariant="dark" placeholder="placeholder"></dashboard-item>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-3 mb-5">
        <company-details :companyForm="company" :isRegistering="false" @save="updateCompany"></company-details>
      </div>
      <div class="mt-3 mb-5">
        <company-settings :companyForm="company" :isRegistering="false" :users="users" v-if="company != null && hasManagementAccess" @save="updateCompany" />
      </div>
      <div class="mt-3 mb-5">
        <order-list :orders="orders" v-if="orders != null"></order-list>
      </div>
    </div>
    <no-data-box v-if="company == null">
      <h5>
        {{ $t(LangConstants.no_company_message) }}
      </h5>
    </no-data-box>
  </div>
</template>

<script>
import Constants from "../../constants/index";

import DashboardItem from "../../components/organisms/DashboardItem.vue";
import OrderList from "../../components/organisms/OrderList.vue";
import CompanyDetails from "../../components/organisms/CompanyDetails.vue";
import CompanySettings from "../../components/organisms/CompanySettings.vue";
import NoDataBox from "../../components/atoms/NoDataBox.vue";

import ToggleSimple from "../../components/atoms/ToggleSimple.vue";
import Common from "../../functions/index";

export default {
  name: "customer-profile",

  async created() {
    if (this.$route.params.id) {
      this.company = this.allCompanies.find((c) => c.companyid == this.$route.params.id);

      this.company.maximum_license = this.company.maximum_license == 999999999 ? "*" : this.company.maximum_license;
      this.companyName = this.company.name;
      let subscriptionForm = {
        instance_id: this.company.instance_id,
        companyid: this.company.companyid,
      };

      const subscriptions = await this.$store.dispatch("getCompanySubscription", subscriptionForm);
      this.participantContentItems.push({
        title: subscriptions.last_30_days_student_count,
        text: this.$t(this.LangConstants.new_participants_per_month_text),
        type: "text",
        icon: "fa-arrow-up",
        iconVariant: "success",
      });
      this.participantContentItems.push({
        title: subscriptions.total_students_count,
        text: this.$t(this.LangConstants.participants_all_time_text),
        type: "text",
        icon: "fa-arrow-up",
        iconVariant: "success",
      });
      this.courseCompletionContentItems.push({
        title: subscriptions.last_30_days_total_course_completions,
        text: this.$t(this.LangConstants.last30days),
        type: "text",
      });
      this.courseCompletionContentItems.push({
        title: subscriptions.total_course_completions,
        text: this.$t(this.LangConstants.total_text),
        type: "text",
      });
      this.courseRenewalContentItems.push({
        title:subscriptions.next_3_month_cert_renewals,
        text: this.$t(this.LangConstants.next3months),
        type: "text",
      });
      this.courseRenewalContentItems.push({
        title: subscriptions.next_12_month_cert_renewals,
        text: this.$t(this.LangConstants.next12months),
        type: "text",
      });

      let form = {
        company: {
          companyid: this.company.companyid,
          instance_id: this.company.instance_id,
        },
      };

      const orderList = await this.$store.dispatch("getCompanyOrders", form);
      let successedPayments = [];
      orderList.data.map((payment) => {
        // if (payment.status == "success") {
          successedPayments.push(payment);
        // }
      });
      this.orders = successedPayments;
    }
  },

  data() {
    return {
      company: null,
      participantContentItems: [],
      courseCompletionContentItems: [],
      courseRenewalContentItems: [],
      companyName: null,
      orders: null,
    };
  },

  computed: {
    LangConstants() {
      return Constants;
    },

    hasManagementAccess() {
      return Common.isAuthUser(Constants.trainingmanager);
    },

    users() {
      return this.$store.getters.teamLeads;
    },

    allCompanies() {
      return this.$store.getters.allCompanies;
    },

    parentCustomerId() {
      const authUser = this.$store.getters.getAuthUser;
      return authUser.customer_instance.id;
    },
  },

  methods: {
    goBack() {
      this.$router.push({ name: "CustomerManagement" });
    },

    async updateCompanyActivation(value) {
      this.company.active = value;
      await this.updateCompany({ active: value });
    },

    async updateCompanyDetails() {
      /*let updatedInfo = {
        name: this.company.name,
        organization_number: this.company.organization_number,
        invoice_email: this.company.invoice_email,
        address: this.company.address,
        phone: this.company.phone,
        postal_code: this.company.postal_code,
        city: this.company.city,
        country: this.company.country,
        invoice_reference: this.company.invoice_reference,
      }*/
      await this.updateCompany();
    },

    async updateCompanySettings() {
      /*let updatedInfo = {
        team_lead_userid: this.company.team_lead_userid,
        allow_invoice: this.company.allow_invoice,
        maximum_license: this.company.maximum_license,
        discount: parseInt(this.company.discount),
      }*/
      await this.updateCompany();
    },

    async updateCompany() {
      try {
        this.company.discount = parseInt(this.company.discount);
        this.company.maximum_license = this.company.maximum_license == "*" ? 999999999 : this.company.maximum_license;

        // let jsondata = "companyname=" + this.company.name;
        // jsondata += "%26id=" + this.company.id;
        // jsondata += "%26organizationnumber=" + this.company.organization_number;
        // jsondata += "%26customercontact=" + this.company.team_lead_userid;
        // jsondata += "%26instance=" + this.company.instance_id;
        // //jsondata +="%26invoiceallowed="+this.company.allow_invoice == true ? 1 : 0;
        // jsondata += "%26phone=" + this.company.phone;
        // jsondata += "%26address=" + this.company.address;
        // jsondata += "%26postalcode=" + this.company.postal_code;
        // jsondata += "%26city=" + this.company.city;
        // jsondata += "%26discount=" + this.company.discount;
        // jsondata += "%26parentcustomerid=" + this.parentCustomerId;
        // jsondata += "%26invoice_reference=" + this.company.invoice_reference;
        // jsondata += "%26invoice_email=" + this.company.invoice_email;
        // jsondata += "%26max_licenses=" + this.company.maximum_license;
        // jsondata += "%26country=" + this.company.country;

        let payload = {
        
            companyname: this.company.name,
            id: this.company.companyid,
            organizationnumber: this.company.organization_number,
            customercontact: this.company.team_lead_userid,
            instance: this.company.instance_id,
            invoiceallowed: this.company.allow_invoice == true ? 1 : 0,
            phone: this.company.phone,
            address: this.company.address,
            postalcode: this.company.postal_code,
            city: this.company.city,
            discount: this.company.discount,
            parentcustomerid: this.parentCustomerId,
            invoice_reference: this.company.invoice_reference,
            invoice_email: this.company.invoice_email,
            max_licenses: this.company.maximum_license,
            country: this.company.country,
            active : this.company.active,
          
        };

        payload =  JSON.stringify(payload);

        let form = {
          token_retrieval_url: "/login/token.php?username=wsuser&password=wsUs3eR@s!te&service=sparkforeapi",
          // update_url: '/webservice/rest/server.php?wstoken=<WS_TOKEN_HERE>&wsfunction=local_sparkfore_update_company&moodlewsrestformat=json&jsondata="' + jsondata + '"',
          update_url: '/webservice/restful/server.php/local_sparkfore_update_company',
          payload : payload,
        };
        // let form = {
        //    id : this.company.id,
        //    instance_id : this.company.instance_id,
        //    company : updatedInfo,
        //    updatedCompany : this.company
        // }
        const response = await this.$store.dispatch("companyUpdate", form);
        var result = JSON.parse(response);
        if (result.success == true) {
          this.company = this.allCompanies.find((c) => c.companyid == this.$route.params.id);
          this.companyName = this.company.name;
          this.$fire({
            title: this.$t(this.LangConstants.customer_profile_update_success_heading),
            text: this.$t(this.LangConstants.customer_profile_update_success_message),
            type: "success",
          });
        } else {
          this.$fire({
            title: this.$t(this.LangConstants.customer_profile_update_fail_heading),
            text: this.$t(this.LangConstants.customer_profile_update_fail_heading),
            type: "error",
            html: "",
          });
        }
      } catch (error) {
        this.company = this.allCompanies.find((c) => c.companyid == this.$route.params.id);
        this.companyName = this.company.name;
        this.$fire({
          title: this.$t(this.LangConstants.customer_profile_update_fail_heading),
          text: this.$t(this.LangConstants.customer_profile_update_fail_heading),
          type: "error",
          html: "<div>" + this.$t(error) + "</div>",
        });
      }
    },
  },

  components: {
    DashboardItem,
    OrderList,
    CompanyDetails,
    CompanySettings,
    ToggleSimple,
    NoDataBox,
  },
};
</script>
